import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { AppColors } from "../../../../../util/AppColors";
import AddItemsDrawer from "./AddItemsDrawer";
import AddProcedureDrawer from "./AddProcedureDrawer";
import EditProcedureDrawer from "./EditProcedureDrawer";
import ProcedureCard from "./ProcedureCard";

const ProceduresSection = () => {
  const [isAddDrawerOpen, setIsAddDrawerOpen] = useState(false);
  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);
  const [isAddItemsDrawerOpen, setIsAddItemsDrawerOpen] = useState(false);
  const [selectedProcedure, setSelectedProcedure] = useState(null);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const petAndApntData = useSelector(
    (state) => state?.pet?.petAndAppointmentDetails,
  );

  const handleOpenAddDrawer = () => {
    setIsAddDrawerOpen(true);
  };

  const handleOpenEditDrawer = (proc) => {
    setSelectedProcedure(proc);
    setIsEditDrawerOpen(true);
  };

  const handleOpenAddItemsDrawer = (proc) => {
    setSelectedProcedure(proc);
    setIsAddItemsDrawerOpen(true);
  };

  return (
    <Box sx={{ width: "100%", pt: 1, pb: 4 }}>
      {/* Section Header */}
      <Box mb={2.5}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: AppColors.appPrimary,
            fontSize: "18px",
            mb: 0.5,
          }}
        >
          Procedures ({reqDet?.procedures?.length})
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            color: "#616161",
            lineHeight: 1.4,
          }}
        >
          Add consumables or administered items against a procedure in the
          sections below{" "}
          {!!petAndApntData?.inpatientResponse?.patientId &&
          !!petAndApntData?.appointment?.inpatient
            ? `— or let Treatment Plan items populate them automatically when marked “Given”.`
            : ""}
        </Typography>
      </Box>

      {/* Procedures Card List */}
      <Box mb={2}>
        {[...(reqDet?.procedures ?? [])]
          ?.sort((a, b) => a.procedureId - b.procedureId)
          ?.map((proc) => (
            <ProcedureCard
              key={proc.procedureId}
              procedure={proc}
              onEdit={handleOpenEditDrawer}
              onAddItems={handleOpenAddItemsDrawer}
            />
          ))}
      </Box>

      {/* Add Procedure Dashed Button */}
      <Box
        onClick={handleOpenAddDrawer}
        sx={{
          border: "1.5px dashed #90caf9",
          borderRadius: "8px",
          backgroundColor: "#f8faff",
          py: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: "#eef4ff",
            borderColor: AppColors.appPrimary || "#0054A6",
          },
        }}
      >
        <Button
          startIcon={<AddIcon sx={{ fontSize: 20 }} />}
          sx={{
            color: AppColors.appPrimary || "#0054A6",
            fontWeight: 700,
            fontSize: "14px",
            textTransform: "none",
            pointerEvents: "none",
          }}
        >
          Add procedure
        </Button>
      </Box>

      {/* Drawers */}
      <AddProcedureDrawer
        open={isAddDrawerOpen}
        onClose={() => setIsAddDrawerOpen(false)}
      />

      <EditProcedureDrawer
        open={isEditDrawerOpen}
        onClose={() => setIsEditDrawerOpen(false)}
        procedure={selectedProcedure}
      />

      <AddItemsDrawer
        open={isAddItemsDrawerOpen}
        onClose={() => setIsAddItemsDrawerOpen(false)}
        procedure={selectedProcedure}
      />
    </Box>
  );
};

export default ProceduresSection;
